<template>
    <div class="project__spend-box">
        <div
            class="spend-box"
            :class="{
                'spend-box--enter-code': !spended && !code,
                'spend-box--input-ready': !spended && code,
                'spend-box--spent': spended
            }"
        >
            <div class="spend-box__header">
                <img src="@/assets/img/heart-w.png" alt="Herzen">
                <h2 v-if="!projectClosed">
                    Herzen verteilen für dieses Projekt
                </h2>
                <h2 v-else>
                    Dieses Projekt ist abgeschlossen
                </h2>
            </div>
            <div class="spend-box__enter-code" v-if="!projectClosed">
                Bitte geben Sie zuerst oben auf der Seite Ihren Code ein. <br>
                <strong>
                    Sie haben keinen Code? <a @click="$emit('scroll-to', '#note')">Weitere Infos</a>
                </strong>
            </div>
            <div class="spend-box__input" v-if="heartsAvailable">
                <div class="spend-box__input-select">
                    <select class="form-control" v-model="heartsToSpend" id="hearts-count">
                        <option value="0">
                            Anzahl der Herzen
                        </option>
                        <option
                            v-for="index in code.hearts_left"
                            :key="index"
                            :value="index"
                        >
                            {{ index }}
                        </option>
                    </select>
                </div>
                <div class="spend-box__input-trigger" @click="spendProject">
                    <span class="mdi mdi-check"></span> Spenden
                </div>
            </div>
            <div class="spend-box__spent-message">
                <span class="mdi mdi-emoticon"></span> <br> Vielen Dank für Ihre Spende.
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'SpendBox',

    props: {
        projectId: {
            type: Number,
            required: true
        },

        projectClosed: {
            type: Boolean,
            required: true
        }
    },

    data () {
        return {
            spended: false,
            heartsToSpend: 0
        }
    },

    computed: {
        ...mapState([
            'code'
        ]),

        heartsAvailable () {
            if (!this.code) {
                return false
            }

            return parseInt(this.code.hearts_left) > 0
        }
    },

    methods: {
        spendProject () {
            if (!this.heartsToSpend) {
                return
            }

            const params = {
                projectId: this.projectId,
                code: this.code.code,
                count: this.heartsToSpend
            }

            this.$store.dispatch('spendProject', params).then(() => {
                this.spended = true
                const timer = setTimeout(() => {
                    this.spended = false
                    clearTimeout(timer)
                }, 1500)
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/SpendBox.vue